<template>
    <ContentOrLoading>
        <template v-if="!loading">
            <b-col cols="12" class="pb-3 pr-0 pl-0">
                <b-alert show variant="warning">
                    El envío de comunicados por WhatsApp tendrá un coste de <b>{{ teatro.coste_envio_whatsapp_marketing | formatear_precio }}</b> por cada mensaje enviado. <br/>
                    El importe se descontará automaticamente en la siguiente liquidación.
                </b-alert>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <FormInput label="Asunto (Esto no aparece a los usuarios, únicamente es identificativo)" type="text" name="asunto" id="asunto" rules="required" v-model="comunicado.asunto" />
            </b-col>            
            <b-col cols="12" class="pl-0 pr-0" v-if="plantillas">
                <label for="plantilla">Selecciona la plantilla</label>
                <ValidationProvider name="plantilla" rules="required" v-slot="{ errors }">
                    <multiselect
                        v-model="comunicado.whatsapp_template"
                        id="plantilla"
                        placeholder="Plantillas"
                        track-by="id"
                        label="name"
                        :options="plantillas"
                    />
                    <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                </ValidationProvider>

                <div v-if="comunicado.whatsapp_template" class="mt-3">
                    <h4>Vista previa de la plantilla</h4>
                    <VistaPreviaComponent :components="comunicado.whatsapp_template.components" :key="comunicado.whatsapp_template.id" />
                </div>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0 mt-3">
                <div class="form-group">
                    <label for="fecha de envío">Fecha de envio</label>
                    <ValidationProvider name="fecha de envio" rules="required" v-slot="{ errors }">
                        <datetime
                            v-model="comunicado.fecha_envio"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            :min-datetime="new Date().toISOString()"
                            type="datetime"
                            input-id="fecha_envio"
                            value-zone="CET"
                        />
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
        </template>
    </ContentOrLoading>
</template>

<script>
    import VistaPreviaComponent from '../../plantillas-whatsapp/VistaPreviaComponent.vue';

    export default {
        props: {
            comunicado: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                plantillas: null
            }
        },
        methods: {
            getPlantillas() {
                this.updateLoading(true);

                const params = {
                    filters : {
                        status: 1,
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.index'), params).then(res => {
                    this.plantillas = res.data.data;
                    if (!this.comunicado.whatsapp_template && this.comunicado.whatsapp_template_id && this.plantillas?.length > 0) this.comunicado.whatsapp_template = this.plantillas.find(plantilla => plantilla.id === this.comunicado.whatsapp_template_id);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.updateLoading(false);
                });
            },
            updateLoading(estado) {
                this.$emit('update:loading', estado);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getPlantillas();
        },
        components: {
            VistaPreviaComponent
        }
    }
</script>